module.exports = {
  object: require('./object'),
  array: require('./array'),
  regex: require('./regexp')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/badwords-list/lib/index.js
// module id = 344
// module chunks = 3